/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { Fragment, useState } from 'react';
import Collapsible from 'react-collapsible';
import { useTranslation } from 'react-i18next';
import commons from '../../../commons/commons';
import './precio-resumen.css';

const PriceElement = ({ label, value, currency }) => (
  value ? (
    <div className='flex flex-row justify-between'>
      <span className='pr-5 titulo-precio'>{label}</span>
      <span className='pl-3 titulo-precio'>
        {`${currency} ${commons.numberFixedToMoney(value)}`}
      </span>
    </div>
  ) : null
);

function PrecioResumen({
  priceInformation, finalPrice, labelPrice, note = false,
}) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const toggle = () => setActive(!active);

  // take the price labes from father and use here

  const priceComponents = () => {
    let dataset = [
      { label: t('checkout.priceTerms.productPrice'), value: priceInformation.precioNeto },
      { label: t('checkout.priceTerms.taxesRates'), value: priceInformation.impuestos + priceInformation.iva },
    ];
    if (priceInformation.moneda === 'ARS') {
      dataset = dataset.concat([
        { label: t('checkout.priceTerms.countryTax'), value: priceInformation.impuestoPais },
        { label: t('checkout.priceTerms.rgTax'), value: priceInformation.irgAfip },
      ]);
    }
    return dataset;
  };

  const priceElements = priceComponents().map((item) => (
    <PriceElement
      key={`${priceInformation.moneda} ${item.value}`}
      currency={priceInformation.moneda}
      {...item}
    />
  ));

  return (
    <div className='container bg-white my-4 p-6'>
      <div className='panel-heading' role='tab' id='headingOne'>
        <Collapsible trigger={(
          <h4
            className='arrow-panel-title'
            role='button'
            onClick={toggle}
          >
            <small className='titulo-precio'>{labelPrice}</small>
            <div>
              <b>
                <span className='titulo-precio'>{priceInformation.moneda}</span>
                &nbsp;
                <span className='precio-final'>{finalPrice}</span>
              </b>
            </div>
          </h4>
        )}
        >
          <div
            className={active === false ? 'accordion-closed' : 'accordion-open'}
            style={{ transition: 'all 3500ms ease-out' }}
          >
            <div>
              <dl className='flex flex-col'>
                {priceElements}
              </dl>
              <div className='nota-dolares'>
                <br />
                {note && (
                  <Fragment>
                    <div className='titulo' style={{ fontWeight: 600 }}>
                      Nota:
                    </div>
                    <div className='texto' style={{ fontWeight: 300, whiteSpace: 'pre-wrap' }}>
                      {note}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </Collapsible>
      </div>
    </div>
  );
}

export default PrecioResumen;
